export default {
  freeShippingWithoutDates: {
    id: 'product_page_shipping_without_date',
    defaultMessage: 'Free delivery',
  },
  freeShipping: {
    id: 'product_page_shipping_with_date',
    defaultMessage: 'Get it between {dates, html} free standard shipping',
  },
  freeShippingDates: {
    id: 'product_page_shipping_dates',
    defaultMessage: '{earliest} and {latest}',
  },
  expressShipping: {
    id: 'product_page_express_shipping',
    defaultMessage: 'Get it from {amount} between {earliest} and {latest}',
  },
  freeShippingBeforeChristmas: {
    id: 'product_page_shipping_free_before_christmas',
    defaultMessage: 'Free delivery before Christmas, {earliest} - {latest}',
  },
  expressShippingBeforeChristmas: {
    id: 'product_page_shipping_express_before_christmas',
    defaultMessage: 'Express delivery before Christmas, {earliest} - {latest}',
  },
  freeShippingDaysRange: {
    id: 'checkout_shipping_day_range_standard',
    defaultMessage: 'Free delivery in {earliest}-{latest} days',
  },
  expressShippingDaysRange: {
    id: 'checkout_shipping_day_range_express',
    defaultMessage: 'Express in {earliest}-{latest} days from {amount}',
  },
  freeShippingMaxDay: {
    id: 'checkout_shipping_max_day_standard',
    defaultMessage: 'Free delivery in {max} days',
  },
  expressShippingMaxDay: {
    id: 'checkout_shipping_max_day_express',
    defaultMessage: 'Express in {max} days from {amount}',
  },
}
